import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import {
  GetUsersDioScheduledVisitsByActiveVoucherRequest, GetUsersDioScheduledVisitsByActiveVoucherResponse,
  GetServedServicePointsByActiveVoucherResponse, GetServedServicePointsByActiveVoucherRequest, GetServicePointsResponse,
  GetServicePointsRequest, GetServedServicePointResponse, GetServedServicePointRequest, PostServedServicePointRequest,
  PostServedServicePointResponse, PostPackageCountRequest, PostPackageCountResponse, UpdatePackageCountsRequest,
  UpdatePackageCountsResponse, GetDioPackageTypesRequest, GetDioPackageTypesResponse, DeletePackageCountRequest,
  DeletePackageCountResponse, SetReceiverRequest, SetReceiverResponse, SetRejectReasonRequest, SetRejectReasonResponse,
  GetServedServicePointsForUnloadingRequest, GetServedServicePointsForUnloadingResponse, UnloadServicePointsRequest,
  UnloadServicePointsResponse, GenerateClientPdfRequest, GenerateClientPdfResponse
} from '../models/dio.models';

@Injectable({
  providedIn: 'root'
})
export class DioService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getUsersDioScheduledVisits(request: GetUsersDioScheduledVisitsByActiveVoucherRequest): Observable<GetUsersDioScheduledVisitsByActiveVoucherResponse> {
    return this.http.get<GetUsersDioScheduledVisitsByActiveVoucherResponse>(`${this.apiUrl}/CourierApp/GetDioScheduledVisits`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  getServedServicePoints(request: GetServedServicePointsByActiveVoucherRequest): Observable<GetServedServicePointsByActiveVoucherResponse> {
    return this.http.get<GetServedServicePointsByActiveVoucherResponse>(`${this.apiUrl}/CourierApp/GetVisitedServicePoints`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  getServicePoints(request: GetServicePointsRequest): Observable<GetServicePointsResponse> {
    return this.http.get<GetServicePointsResponse>(`${this.apiUrl}/CourierApp/GetServicePoints`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  postServedServicePoint(request: PostServedServicePointRequest): Observable<PostServedServicePointResponse> {
    return this.http.post<PostServedServicePointResponse>(`${this.apiUrl}/CourierApp/PostServedServicePoint`, request, { headers: this.getHeaders() });
  }

  getServedServicePoint(request: GetServedServicePointRequest): Observable<GetServedServicePointResponse> {
    return this.http.get<GetServedServicePointResponse>(`${this.apiUrl}/CourierApp/GetServedServicePoint`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  postPackageCount(request: PostPackageCountRequest): Observable<PostPackageCountResponse> {
    return this.http.post<PostPackageCountResponse>(`${this.apiUrl}/CourierApp/PostPackageCount`, request, { headers: this.getHeaders() });
  }

  updatePackageCounts(request: UpdatePackageCountsRequest): Observable<UpdatePackageCountsResponse> {
    return this.http.post<UpdatePackageCountsResponse>(`${this.apiUrl}/CourierApp/UpdatePackageCounts`, request, { headers: this.getHeaders() });
  }

  getDioPackageTypes(request: GetDioPackageTypesRequest): Observable<GetDioPackageTypesResponse> {
    return this.http.get<GetDioPackageTypesResponse>(`${this.apiUrl}/CourierApp/GetDioPackageTypes`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  deletePackageCount(request: DeletePackageCountRequest): Observable<DeletePackageCountResponse> {
    return this.http.post<DeletePackageCountResponse>(`${this.apiUrl}/CourierApp/DeletePackageCount`, request, { headers: this.getHeaders() });
  }

  setReceiver(request: SetReceiverRequest): Observable<SetReceiverResponse> {
    return this.http.post<SetReceiverResponse>(`${this.apiUrl}/CourierApp/SetReceiver`, request, { headers: this.getHeaders() });
  }

  setRejectReason(request: SetRejectReasonRequest): Observable<SetRejectReasonResponse> {
    return this.http.post<SetRejectReasonResponse>(`${this.apiUrl}/CourierApp/SetRejectReason`, request, { headers: this.getHeaders() });
  }

  getServedServicePointsForUnloading(request: GetServedServicePointsForUnloadingRequest): Observable<GetServedServicePointsForUnloadingResponse> {
    return this.http.get<GetServedServicePointsForUnloadingResponse>(`${this.apiUrl}/CourierApp/GetServedServicePointsForUnloading`, {
      headers: this.getHeaders(),
      params: this.getQueryParams(request)
    });
  }

  unloadServicePoints(request: UnloadServicePointsRequest): Observable<UnloadServicePointsResponse> {
    return this.http.post<UnloadServicePointsResponse>(`${this.apiUrl}/CourierApp/UnloadServicePoints`, request, { headers: this.getHeaders() });
  }

  generateClientPdf(request: GenerateClientPdfRequest): Observable<GenerateClientPdfResponse> {
    return this.http.post<GenerateClientPdfResponse>(`${this.apiUrl}/CourierApp/GenerateClientPdf`, request, { headers: this.getHeaders() });
  }
}